// Effective tool rights of the signed-in person (2026-10-13 "Customise access").
// The server computes them ONCE (backend/auth/access.js effectiveTools = team preset + per-person overrides) and sends them as
// user.tool_rights { tool: "view"|"edit" } on /api/account/me. Screens read them through these helpers - never re-derive the rule.
// Fallback for an older server answer without tool_rights: user.tools at the person's access level (the pre-2026-10-13 rule).
export const toolRights = (user) => {
  if (!user) return {};
  if (user.tool_rights && typeof user.tool_rights === "object") return user.tool_rights;
  const lvl = user.team === "admin" || user.is_admin ? "edit" : user.access === "edit" ? "edit" : "view";
  const out = {};
  (Array.isArray(user.tools) ? user.tools : []).forEach((t) => { out[t] = lvl; });
  return out;
};

// "view" | "edit" | null
export const toolRight = (user, tool) => toolRights(user)[tool] || null;

// Tool ids the person can open (any access).
export const toolList = (user) => Object.keys(toolRights(user));

// "View only" note: in a tool = View on that tool; on the launcher (no tool) = View on every tool they have. Admin never.
export const isViewOnly = (user, tool) => {
  if (!user || user.team === "admin" || user.is_admin) return false;
  const r = toolRights(user);
  if (tool) return r[tool] === "view";
  const vals = Object.values(r);
  return vals.length > 0 && vals.every((v) => v === "view");
};
